import { Pipe, PipeTransform } from '@angular/core';
import { PriceHelper } from '../helpers/price.helper';

@Pipe({
  standalone: true,
  name: 'formattedPrice',
})
export class FormattedPricePipe implements PipeTransform {
  transform(price: number): string {
    return new PriceHelper()
      .centsToPrice(price)
      .toLocaleString('uk-UA', { minimumFractionDigits: 0 });
  }
}
